import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import Banner from "../../components/banner/banner";
import Navigation from "../../components/navigation/Navigation";
import Footer from "../../components/footer/Footer";
import AnnouncementBar from "../../components/announcement/AnnouncementBar";
import ProjectListCard from "../../components/ProjectListCard/ProjectListCard";
import Ai_BlockchainImag from "../../assets/images/Ai_BlockchainImag.png";
import "./Ai_Blockchain.css";

const Ai_Blockchain = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const productCards = [
    {
      category: "Web3",
      featured: true,
      slug: "non-custodial-wallet-management",
      title: "Non-Custodial Wallet Management",
      description:
        "A secure, user-friendly non-custodial wallet solution for managing digital assets across multiple blockchain networks.",
      technologies: ["Solidity", "MERN Stack", "Web3js"],
      features: [
        "Non-custodial security model",
        "Multi-chain support",
        "User-friendly interface",
        "Advanced security features",
        "Developed Before ChatGPT Era",
      ],
    },

    {
      category: "Finance",
      featured: true,
      slug: "trade-finance-with-esg-score",
      title: "Trade Finance with ESG Score",
      description:
        "A blockchain-based trade finance platform that incorporates ESG scoring for sustainable trade practices.",
      technologies: ["Go Language", "Solidity", "XDC Network"],
      features: [
        "ESG scoring integration",
        "Automated trade finance processes",
        "Transparent transaction records",
        "Sustainable trade incentives",
        "Developed Before ChatGPT Era",
      ],
    },

    {
      category: "Blockchain",
      featured: true,
      slug: "synthetic-derivative-protocol-rwa-tokenization",
      title: "Synthetic Derivative Protocol - RWA Tokenization",
      description:
        "A comprehensive Real World Asset (RWA) tokenization platform enabling fractional ownership of physical assets.",
      technologies: ["Solidity", "MERN Stack", "Web3js"],
      features: [
        "Multi-asset tokenization support",
        "Fractional ownership capabilities",
        "Regulatory compliance framework",
        "Liquidity provision mechanisms",
        "Before ChatGPT Era",
      ],
    },

    {
      category: "Infrastructure",
      featured: true,
        slug: "blockchain-as-a-service-platform",
      title: "Blockchain as a Service Platform",
      description:
        "A comprehensive BaaS platform providing enterprise-grade blockchain infrastructure and services.",
      technologies: [
        "Hyperledger Fabric",
        "Docker",
        "Swarm",
        "Go",
        "MERN Stack",
        "Helm",
      ],
      features: [
        "One-click deployment",
        "Enterprise security",
        "Auto-scaling infrastructure",
        "Multi-cloud support",
      ],
    },
    {
      category: "AI",
      featured: true,
      slug: "business-automation-agentic-ai",
      title: "Business Automation with Agentic AI",
      description:
        "An intelligent business automation platform using Agentic AI for the water purifier industry.",
      technologies: [
        "LangGraph",
        "Python",
        "FastAPI",
        "OpenAI",
        "Telegram SDK",
        "LLM",
      ],
      features: [
        "Autonomous business process automation",
        "Multi-channel communication (Telegram, WhatsApp)",
        "Intelligent inventory management",
        "Real-time customer support",
      ],
    },

    {
      category: "AI",
      featured: true,
      slug: "frognosis-data-intelligence-dashboard",
      title: "Frognosis - Data Intelligence Dashboard",
      description:
        "An intelligent data analytics platform delivering real-time insights and predictive intelligence.",
      technologies: ["MEAN Stack", "Redis", "OpenAI"],
      features: [
        "Real-time analytics",
        "Predictive modeling",
        "Interactive dashboards",
        "AI-powered insights",
      ],
    },
    {
      category: "Infrastructure",
      featured: true,
      slug: "blockchain-network-layer-1-blockchain",
      title: "Blockchain Network - Layer 1 Blockchain",
      description:
        "A custom end-to-end blockchain network with explorer, RPC server, and monitoring capabilities.",
      technologies: ["GoLang  Solidity", "Bash Script", "Docker", "NodeJS"],
      features: [
        "Custom blockchain implementation",
        "Blockchain explorer with frontend/backend",
        "RPC server for API access",
        "Master nodes and sync cluster",
        "POS consensus algorithm",
        "Node health monitoring",
        "Faucet for test tokens",
      ],
    },
    {
      category: "AI",
      featured: true,
      slug: "business-automation-agentic-ai-logistics",
      title: "Business Automation with Agentic AI for Logistics",
      description:
        "An intelligent logistics automation platform using Agentic AI to optimize supply chain operations.",
      technologies: [
        "LangGraph",
        "Python",
        "FastAPI",
        "OpenAI",
        "Twilio",
        "LLM",
      ],
      features: [
        "Autonomous logistics optimization",
        "Real-time route planning",
        "Intelligent inventory management",
        "Automated customer communication",
      ],
    },
    {
      category: "AI",
      featured: true,
      slug: "agentic-ai-as-a-service",
      title: "Agentic AI As a Service",
      description:
        "A comprehensive AI-as-a-Service platform providing Agentic AI capabilities for businesses across various industries.",
      technologies: [
        "LangGraph",
        "Python",
        "FastAPI",
        "OpenAI",
        "ReactJS",
        "LLM",
      ],
      features: [
        "Pre-built AI agents for common use cases",
        "Custom agent development",
        "Multi-channel integration",
        "Real-time agent monitoring",
      ],
    },
    {
      category: "AI",
      featured: true,
      slug: "agentic-ai-for-logistics",
      title: " Agentic AI for Logistics",
      description:
        "A comprehensive agents marketplace platform providing Agentic AI capabilities for logistics services.",
      technologies: [
        "LangGraph",
        "Python",
        "FastAPI",
        "OpenAI",
        "ReactJS",
        "LLM",
      ],
      features: [
        "Pre-built AI agents for Logistics use cases",
        "Custom agent development",
        "Multi-channel integration",
        "Real-time agent monitoring",
      ],
    },
    {
      category: "AI",
      featured: true,
      slug: "the-guiding-mind-complete-entrepreneurial-platform",
      title: "The Guiding Mind | Complete Entrepreneurial Platform",
      description:
        "From idea validation to investor-ready pitch decks. Hadi guides entrepreneurs through every step with AI-powered insights, expert advice, and personalized recommendations.",
      technologies: [
        "LangGraph",
        "Python",
        "FastAPI",
        "OpenAI",
        "ReactJS",
        "LLM",
      ],
      features: [
        "Idea to Investment Ready Pitch Deck",
        "Idea Validation",
        "Guided Pitch Deck Creation",
        "Expert Advice",
        "Personalized Recommendations",
      ],
    },
    // {
    //   category: "AI",
    //   featured: true,
    //   title: "TalkLeap - Agentic AI As a Service",
    //   description:
    //     "A comprehensive AI-as-a-Service platform providing Agentic AI capabilities for businesses across various industries.",
    //   technologies: [
    //     "LangGraph",
    //     "Python",
    //     "FastAPI",
    //     "OpenAI",
    //     "ReactJS",
    //     "LLM",
    //   ],
    //   features: [
    //     "Pre-built AI agents for common use cases",
    //     "Custom agent development",
    //     "Multi-channel integration",
    //     "Real-time agent monitoring",
    //   ],
    // },
    {
      category: "Blockchain",
      featured: false,
      slug: "decentralized-oracle-network",
      title: "Decentralized Oracle Network",
      description:
        "A comprehensive decentralized oracle solution built to provide real-time data feeds for smart contracts.",
      technologies: ["Go Language", "Solidity", "Evm Compatible Network"],
      features: [
        "Real-time data feeds for smart contracts",
        "Decentralized node network",
        "Secure data validation mechanisms",
        "High availability and reliability",
        "Developed Before ChatGPT Era",
      ],
    },
    {
      category: "Healthcare",
      featured: false,
      slug: "vaccine-tracking-solution-for-costa-rica",
      title: "Vaccine Tracking Solution for Costa Rica",
      description:
        "A blockchain-based vaccine tracking system ensuring transparency and traceability in the vaccine supply chain, during covid-19 times.",
      technologies: ["Hyperledger Fabric", "Go", "MERN Stack"],
      features: [
        "End-to-end vaccine traceability",
        "Anti-counterfeiting measures",
        "Real-time tracking capabilities",
        "Regulatory compliance features",
        "Developed Before ChatGPT Era",
      ],
    },
    {
      category: "Finance",
      featured: false,
      slug: "rapidflow-finance",
      title: "RapidFlow Finance",
      description:
        "A decentralized finance (DeFi) platform offering lending, borrowing, and yield farming services.",
      technologies: ["Ethereum", "Solidity", "MERN Stack", "Web3js"],
      features: [
        "Decentralized lending and borrowing",
        "Yield farming opportunities",
        "Liquidity provision rewards",
        "Cross-chain compatibility",
      ],
    },
    {
      category: "Web3",
      featured: false,
      slug: "crypto-bridge",
      title: "Crypto Bridge",
      description:
        "A cross-chain bridge enabling seamless asset transfers between Ethereum, Polygon, and XDC networks.",
      technologies: [
        "Ethereum",
        "Polygon",
        "Solidity",
        "XDC Network",
        "Hardhat",
        "Web3js",
      ],
      features: [
        "Multi-chain support",
        "Fast cross-chain transfers",
        "Low transaction fees",
        "Secure bridge protocols",
      ],
    },
    {
      category: "Blockchain",
      featured: false,
      slug: "real-world-asset-tokenization",
      title: "Real World Asset Tokenization",
      description:
        "A comprehensive platform for tokenizing real-world assets on the Ethereum network.",
      technologies: ["Ethereum Network", "Solidity", "MERN Stack"],
      features: [
        "Multi-asset tokenization",
        "Fractional ownership",
        "Regulatory compliance",
        "Liquidity mechanisms",
      ],
    },
    {
      category: "Web3",
      featured: false,
      slug: "nft-marketplace-rarible-like",
      title: "NFT Marketplace (Rarible-like)",
      description:
        "A comprehensive NFT marketplace supporting creation, trading, and management of non-fungible tokens.",
      technologies: ["Ethereum", "Solidity", "MERN Stack", "Web3js", "Polygon"],
      features: [
        "Multi-chain NFT support",
        "Creator tools and royalties",
        "Advanced search and filtering",
        "Secure wallet integration",
      ],
    },
    {
      category: "AI",
      featured: false,
      slug: "data-standardization-governance",
      title: "Data Standardization & Governance",
      description:
        "A comprehensive data governance platform ensuring data quality, consistency, and compliance across organizations.",
      technologies: ["Python", "Apache Spark", "Kylin", "MERN Stack"],
      features: [
        "Automated data validation",
        "Data quality monitoring",
        "Compliance reporting",
        "Data lineage tracking",
      ],
    },
    {
      category: "Finance",
      featured: false,
      slug: "lending-borrowing-protocol",
      title: "Lending & Borrowing Protocol",
      description:
        "A decentralized lending and borrowing protocol built on XDC Network providing secure and efficient financial services.",
      technologies: ["Solidity", "MERN Stack", "Web3js", "XDC Network"],
      features: [
        "Decentralized lending/borrowing",
        "Automated interest calculations",
        "Liquidation mechanisms",
        "Governance token integration",
      ],
    },
  ];
  // const createSlug = (title) =>
  //   title.toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]+/g, "");
  return (
    <>
      <section>
        <Navigation />

        <Banner title="Portfolio Products" bg={Ai_BlockchainImag} />

        <section>
          <Container className="mt-75 mb-75 aiblockchain_section">
            <Row>
              <Col lg="11">
                <div className="aiblockchain_section_title">
                  <h3 className="ai-blockchain-head">
                    Explore my comprehensive portfolio of AI and blockchain
                    products, from autonomous AI systems to enterprise
                    blockchain solutions.
                  </h3>
                </div>
              </Col>
            </Row>

            <Row className="mt-4 g-4 aiblockchain_card_row">
              {productCards.map((item, index) => (
                <Col key={item.title} lg="4" md="6">
                  <ProjectListCard
                    slug={item.slug}
                    category={item.category}
                    featured={item.featured}
                    title={item.title}
                    description={item.description}
                    technologies={item.technologies}
                    features={item.features}
                  />
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <Footer />
      </section>
    </>
  );
};

export default Ai_Blockchain;
